export const TaskStatsIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
        >
            <g clipPath="url(#clip0_1372_1781)">
                <circle cx="10" cy="10" r="10" fill="#7C53A5" />
                <path
                    d="M5 12.0834L7.61905 9.60792L9.58333 11.6667L14.1667 6.66675M14.1667 6.66675H11.875M14.1667 6.66675V9.06871"
                    stroke="white"
                    strokeWidth="1.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_1372_1781">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}
